import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Contact: React.FC = () => {
  return (
    <Container className="py-5">
      <h1 className="text-center display-4 fw-bold text-navy mb-5">Get in Touch</h1>

      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="border-0 shadow-lg h-100">
            <Card.Body className="p-5 text-center">
               <h2 className="h3 fw-bold mb-4">Contact Information</h2>
               <p className="mb-4">
                 Have questions about our programs, financial aid, or upcoming sessions? We'd love to hear from you.
               </p>
               
               <div className="mb-4">
                   <h5 className="fw-bold text-teal">Email Us</h5>
                   <a href="mailto:info@515soccer.org" className="fs-4 text-decoration-none text-navy">info@515soccer.org</a>
               </div>

               <div className="mb-4">
                   <h5 className="fw-bold text-teal">Direct Line</h5>
                   <a href="mailto:bo@515soccer.org" className="text-muted">bo@515soccer.org</a>
               </div>

               <hr />

               <h5 className="fw-bold text-navy mt-4 mb-3">Follow Us</h5>
               <div className="d-flex justify-content-center gap-3">
                   <Button variant="outline-primary" href="https://www.facebook.com/515SoccerAcademy" target="_blank">Facebook</Button>
                   <Button variant="outline-danger" href="https://www.instagram.com/515socceracademy/" target="_blank">Instagram</Button>
                   <Button variant="outline-dark" href="https://www.youtube.com/channel/UCZjN-YRqIJiUc_YqVt29pmA" target="_blank">YouTube</Button>
               </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5} className="mt-4 mt-md-0 d-flex flex-column gap-4">
            <Card className="border-0 shadow-sm bg-teal text-white">
                <Card.Body className="p-4">
                    <h3 className="h4 fw-bold">Financial Assistance</h3>
                    <p>
                        We believe cost should never be a barrier to playing soccer. We offer tiered financial aid based on income, up to 100%.
                    </p>
                    <Button variant="light" className="text-teal fw-bold" href="https://forms.gle/QqQCD3JArjrdNYVf7" target="_blank">
                        Apply for Aid
                    </Button>
                </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                    <h3 className="h4 fw-bold text-navy">Team Store</h3>
                    <p>
                        Get your 515 Soccer Academy gear!
                    </p>
                    <p className="small text-muted mb-2">Password: SOC2025</p>
                    <Button variant="outline-dark" href="https://www.aretyn.store/515-soccer-academy" target="_blank">
                        Visit Store
                    </Button>
                </Card.Body>
            </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
